module.exports = __webpack_public_path__ + "img/school_bus_orange.e85159cc.png";